export const parseProgressPercent = (value) => {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(0, Math.min(100, Math.round(value)));
  }
  const match = String(value)
    .trim()
    .match(/^(-?\d+(?:\.\d+)?)\s*%?$/);
  if (!match) return null;
  return Math.max(0, Math.min(100, Math.round(Number(match[1]))));
};

export const applyProgressBar = (doc, percent) => {
  if (!doc || percent == null) return false;
  const fill = doc.querySelector(".progress__fill");
  const marker = doc.querySelector(".progress__marker");
  const value = doc.querySelector(".progress__value");
  if (!fill || !marker || !value) return false;

  fill.style.width = `${percent}%`;
  marker.style.left = `${percent}%`;
  value.textContent = `${percent}%`;
  marker.classList.toggle("progress__marker--start", percent <= 0);
  marker.classList.toggle("progress__marker--end", percent >= 100);
  return true;
};
